import { X } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Right-side slide-over drawer for read-only record details.
 */
export function DetailDrawer({ open, onClose, title, subtitle, children }) {
  if (!open) return null;
  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-40 bg-black/25 backdrop-blur-sm"
        onClick={onClose}
      />
      {/* Panel */}
      <div
        data-testid="detail-drawer"
        className={cn(
          "fixed right-0 top-0 z-50 flex h-full w-full max-w-md flex-col bg-card shadow-2xl transition-transform duration-300",
          open ? "translate-x-0" : "translate-x-full"
        )}
      >
        {/* Header */}
        <div className="flex items-start justify-between gap-4 border-b border-border bg-[#393F4B] px-5 py-4">
          <div className="min-w-0">
            <h2 className="truncate text-base font-bold text-[#ECF4F7]">{title}</h2>
            {subtitle && <p className="mt-0.5 text-xs text-[#8B9BB8]">{subtitle}</p>}
          </div>
          <button
            type="button"
            onClick={onClose}
            data-testid="detail-drawer-close"
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-[#8B9BB8] hover:bg-[#454D5C] hover:text-[#ECF4F7] transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        {/* Scrollable body */}
        <div className="flex-1 overflow-y-auto p-5 space-y-5">{children}</div>
      </div>
    </>
  );
}

export function DrawerSection({ label, children }) {
  return (
    <div>
      <h3 className="mb-3 text-[10px] font-bold uppercase tracking-[0.18em] text-[#910029]">{label}</h3>
      <div className="space-y-2.5">{children}</div>
    </div>
  );
}

export function DrawerField({ label, value, mono = false }) {
  if (value === null || value === undefined || value === "") return null;
  return (
    <div className="flex items-start justify-between gap-3 rounded-lg bg-muted/30 px-3 py-2.5">
      <span className="shrink-0 text-xs text-muted-foreground">{label}</span>
      <span
        className={cn(
          "text-right text-xs font-medium text-foreground",
          mono && "font-mono"
        )}
      >
        {value ?? "—"}
      </span>
    </div>
  );
}
